<script>
import CookieSelector from "@/components/CookieSelector.vue"
import Modal from "@/components/Modal.vue"
import { mapActions, mapGetters } from "vuex"

export default {
    name: "CookieBanner",
    components: { Modal, CookieSelector },
    data() {
        return {
            isAdvancedView: false,
            config: {
                necessaryCookies: true,
                analyticsCookies: false,
            },
        }
    },
    mounted() {
        this.reloadConsentData()
        this.setIsCookieBannerVisible(!this.$cookieConsent.hasConsented)
    },
    computed: {
        ...mapGetters("reduxi", {
            isCookieBannerVisible: "isCookieBannerVisible",
        }),
    },
    methods: {
        ...mapActions("reduxi", {
            setIsCookieBannerVisible: "setIsCookieBannerVisible",
        }),
        onAdvancedViewClose() {
            this.isAdvancedView = false
        },
        closeBanner() {
            this.isAdvancedView = false
        },
        onCustomSettingsClick() {
            this.isAdvancedView = true
        },
        reloadConsentData() {
            let consentData = this.$cookieConsent.getConsentData()
            this.config = consentData.config
        },
        saveCookies() {
            this.$cookieConsent.updateConsent(this.config)
            this.setIsCookieBannerVisible(false)
        },
        onAcceptAllClick() {
            this.config.necessaryCookies = true
            this.config.analyticsCookies = true
            this.saveCookies()

            this.closeBanner()
        },
        onNecessaryOnlyClick() {
            this.config.necessaryCookies = true
            this.config.analyticsCookies = false
            this.saveCookies()

            this.closeBanner()
        },
        onSaveClick() {
            this.saveCookies()

            this.closeBanner()
        },
    },
}
</script>

<template>
    <div class="cookie-banner" v-if="isCookieBannerVisible">
        <div class="cookie-banner-inner">
            <p class="cookie-banner-description">
                {{ $t("cookie_consent.message") }}
                <button class="p-0 btn btn-link" @click="onCustomSettingsClick">
                    {{ $t("cookie_consent.customize_selection") }}
                </button>
            </p>
            <div class="cookie-banner-info"></div>
            <div class="cookie-banner-actions">
                <button class="btn btn-secondary" @click="onNecessaryOnlyClick()">
                    {{ $t("cookie_consent.only_necessary") }}
                </button>
                <button class="btn btn-primary" @click="onAcceptAllClick()">
                    {{ $t("cookie_consent.accept_all") }}
                </button>
            </div>
        </div>

        <Modal
            v-if="isAdvancedView"
            :title="$t('cookie_consent.header')"
            @close="closeBanner"
            :close-on-mask-click="false"
        >
            <template #body>
                <CookieSelector v-model="config" />
            </template>
            <template #footer>
                <div class="d-flex justify-content-between align-items-center">
                    <button class="btn btn-sm btn-secondary" @click="onSaveClick">
                        {{ $t("cookie_consent.confirm_selection") }}
                    </button>
                    <button class="btn btn-sm btn-primary" @click="onAcceptAllClick">
                        {{ $t("cookie_consent.accept_all") }}
                    </button>
                </div>
            </template>
        </Modal>
    </div>
</template>

<style scoped></style>
